// Reference: https://mui.com/material-ui/customization/theming/
import { themeGlobal } from "./themeGlobal.js";

const colors = themeGlobal.palette;

export const themeDark = {
	palette: {
		mode: "dark",
		divider: "#ffffff",
		background: {
			default: "#232331",
			paper: "#1c1c1e",
			contrastText: "#ffffff",
		},
		text: {
			primary: "#ffffff",
			secondary: "#d9dcde",
			disabled: "#5B5B5B",
		},
		action: {
			active: "#ffffff",
			hover: "rgba(255, 255, 255, 0.04)",
			hoverOpacity: 0.04,
			selected: "rgba(255, 255, 255, 0.08)",
			selectedOpacity: 0.08,
			disabled: "rgba(255, 255, 255, 0.26)",
			disabledBackground: "rgba(255, 255, 255, 0.12)",
			disabledOpacity: 0.38,
			focus: "rgba(255, 255, 255, 0.12)",
			focusOpacity: 0.12,
			activatedOpacity: 0.12,
		},
	},
};

/*
{
    "mode": "dark",
    "primary": {
        "main": "#6138f5",
        "light": "#6138f5",
        "dark": "#6138f5",
        "contrastText": "#fff"
    },
    "secondary": {
        "main": "#f50057",
        "light": "rgb(247, 51, 120)",
        "dark": "rgb(171, 0, 60)",
        "contrastText": "#fff"
    },
    "error": {
        "main": "#F15060",
        "light": "#F15060",
        "dark": "#F15060",
        "contrastText": "#fff"
    },
    "warning": {
        "main": "#fa9f47",
        "dark": "#fa9f47",
        "light": "#fa9f47",
        "contrastText": "rgba(0, 0, 0, 0.87)"
    },
    "info": {
        "main": "#007cf0",
        "light": "#007cf0",
        "dark": "#007cf0",
        "contrastText": "#fff"
    },
    "success": {
        "main": "#2c856b",
        "light": "#2c856b",
        "dark": "#2c856b",
        "contrastText": "#fff"
    },
    "common": {
        "black": "#000",
        "white": "#fff"
    },
    "grey": {
        "50": "#fafafa",
        "100": "#f5f5f5",
        "200": "#eeeeee",
        "300": "#e0e0e0",
        "400": "#bdbdbd",
        "500": "#9e9e9e",
        "600": "#757575",
        "700": "#616161",
        "800": "#424242",
        "900": "#212121",
        "A100": "#f5f5f5",
        "A200": "#eeeeee",
        "A400": "#bdbdbd",
        "A700": "#616161"
    },
    "contrastThreshold": 3,
    "tonalOffset": 0.2,
    "text": {
        "primary": "#ffffff",
        "secondary": "#ffffff",
        "disabled": "#ffffff"
    },
    "divider": "#e4ebee",
    "background": {
        "paper": "#1c1c1e",
        "default": "#232331",
        "contrastText": "#ffffff"
    },
    "action": {
        "active": "rgba(0, 0, 0, 0.54)",
        "hover": "rgba(0, 0, 0, 0.04)",
        "hoverOpacity": 0.04,
        "selected": "rgba(0, 0, 0, 0.08)",
        "selectedOpacity": 0.08,
        "disabled": "rgba(0, 0, 0, 0.26)",
        "disabledBackground": "rgba(0, 0, 0, 0.12)",
        "disabledOpacity": 0.38,
        "focus": "rgba(0, 0, 0, 0.12)",
        "focusOpacity": 0.12,
        "activatedOpacity": 0.12
    }
}
*/
